import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';

import { Alert } from '@app/core/domain';
import { AlertStore, AlertStateModel } from './alert.store';

@Injectable()
export class AlertQuery extends QueryEntity<AlertStateModel, Alert> {

  constructor(protected store: AlertStore) {
    super(store);
  }
}
